/** Load lifecycle events (decoupled from Resource/Progress to avoid barrel import cycles). */
export enum LOAD_EVENT {
  'START' = 'start',
  'PROGRESS' = 'progress',
  'LOADED' = 'loaded',
  'COMPLETE' = 'complete',
  'ERROR' = 'error',
}
